<div class="d-flex flex-column flex-root app-root" id="kt_app_root">
  <div class="app-page flex-column flex-column-fluid" id="kt_app_page">
    <div
      class="app-wrapper flex-column flex-row-fluid mt-0"
      id="kt_app_wrapper"
    >
      <!--Toggle Sidebar-->
      <div
        class="d-flex align-items-center d-lg-none ms-n3 me-1 me-md-2 px-6"
        title="Show sidebar menu"
      >
        <div
          class="btn btn-icon btn-active-color-primary w-35px h-35px"
          id="kt_app_sidebar_mobile_toggle"
        >
          <i class="fa-solid fa-bars"></i>
        </div>
      </div>
      <app-sidebar></app-sidebar>
      <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
        <router-outlet></router-outlet>
        <!--Footer-->
        <app-footer></app-footer>
      </div>
    </div>
  </div>
</div>

<!--Scrolltop-->
<app-scroll-to-top></app-scroll-to-top>
